/* Product story section (sections/product-story.liquid).
   The page root clips horizontal overflow, which stops position: sticky from working, so the
   section bar is fixed under the theme's header from script once it reaches the top. The bar
   also underlines the panel in view and jumps to a panel when a link is clicked. Buy box
   footnote links (#study-footnotes) jump to the study footnotes and highlight them. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const header = () => document.getElementById('header');

  // Space the fixed theme header takes at the top of the window right now.
  function headerBottom() {
    const el = header();
    if (!el || getComputedStyle(el).position !== 'fixed') return 0;
    return Math.max(0, el.getBoundingClientRect().bottom);
  }

  function init(story) {
    if (story.dataset.psReady) return;
    story.dataset.psReady = 'true';

    const nav = story.querySelector('[data-ps-nav]');
    const bar = story.querySelector('[data-ps-bar]');
    const list = bar.querySelector('.ps-nav__list');
    const links = [...list.querySelectorAll('a')];
    const panels = links.map((a) => story.querySelector(a.getAttribute('href')));
    const stickyHeader = story.dataset.stickyHeader === 'true';
    let barHeight = 0;
    let current = null;
    let ticking = false;

    function measure() {
      barHeight = bar.offsetHeight;
      nav.style.height = `${barHeight}px`;
    }

    function mark(link) {
      if (link === current) return;
      current = link;
      links.forEach((a) => (a === link ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
      if (link && list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: link.offsetLeft - list.clientWidth / 2 + link.offsetWidth / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }

    function update() {
      ticking = false;
      const top = headerBottom();
      const fixed = nav.getBoundingClientRect().top <= top && story.getBoundingClientRect().bottom > top + barHeight;
      bar.classList.toggle('is-fixed', fixed);
      bar.style.top = fixed ? `${top}px` : '';

      const line = top + barHeight + window.innerHeight * 0.25;
      let inView = null;
      panels.forEach((panel, i) => { if (panel && panel.getBoundingClientRect().top <= line) inView = links[i]; });
      mark(inView || links[0]);
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    // Header height to allow for once the page has scrolled away from the top.
    function offsetAfterJump() {
      const el = header();
      return stickyHeader && el ? el.offsetHeight : 0;
    }

    function jumpTo(target, extra = 0) {
      const y = target.getBoundingClientRect().top + window.scrollY - offsetAfterJump() - barHeight - 8 - extra;
      window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    // stopPropagation keeps the site-wide anchor scroller in emme-diane.js.liquid (a document
    // handler for a[href*="#"]) from also scrolling the target up under the header.
    links.forEach((link, i) => {
      link.addEventListener('click', (event) => {
        if (!panels[i]) return;
        event.preventDefault();
        event.stopPropagation();
        jumpTo(panels[i]);
      });
    });

    document.querySelectorAll('a[href="#study-footnotes"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const notes = document.getElementById('study-footnotes');
        if (!notes) return;
        event.preventDefault();
        event.stopPropagation();
        jumpTo(notes, 140);
        notes.classList.add('is-flash');
        setTimeout(() => notes.classList.remove('is-flash'), 1800);
      });
    });

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { measure(); onScroll(); });
  }

  const start = () => document.querySelectorAll('[data-product-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
